module.exports = __webpack_public_path__ + "media/images/home-2-fa16d9421dd66826f41a5461e05bb939.svg";